module.exports = __webpack_public_path__ + "img/banner3.168e8160.png";